import React from "react";

import EntitySearchFilter from '@javascript/reactComponents/facetSearch/entities/EntitySearchFilter';

const TherapiesSearchFilter = () => {
  const config = {
    icon: "variable",
    maxDisplayItems: 10,
    showCrmInfo: false,
    title: Zymewire.facet_search_filters.therapies,
    tooltip: Zymewire.facet_panel_title_texts.therapies,
  };

  return (
    <EntitySearchFilter
      config={config}
      type="therapies"
    />
  );
};

window.TherapiesSearchFilter = TherapiesSearchFilter;
export default TherapiesSearchFilter;
